import { useSearchParams } from 'react-router'

const usePagination = (defaultLimit = 20, namespace?: string) => {
  const [searchParams, setSearchParams] = useSearchParams()

  const pageKey = namespace ? `${namespace}_page` : 'page'
  const page = parseInt(searchParams.get(pageKey) || '1', 10)

  const setPage = (newPage: number) => {
    const params = new URLSearchParams(window.location.search)
    params.set(pageKey, String(newPage))
    setSearchParams(params)
  }

  return {
    page,
    limit: defaultLimit,
    setPage,
  }
}
export default usePagination
